import React from 'react';
import './PageWrapper.scss';
import SPXLogo from 'assets/static/logo/spx_logo.svg';

export const PageWrapper = (props) => {
  const { children } = props;
  return (
    <div className='page-wrapper'>
      <div className='header'>
        <div className='logo'>
          <img src={SPXLogo} alt='SPX Instant' />
        </div>
      </div>
      <div className='content'>
        {children}
      </div>
    </div>
  );
};
